@if (country && flags[country]) {
  <img [attr.src]="flags[country]" alt="" class="flag" width="16" height="16">
}
